export enum GrowthbookFlagsEnum {
  CommunityEmbeddedCode = 'community-embedded-code',
  WhiteLabel = 'WhiteLabel',
  DSPhysicalProduct = 'DSPhysicalProduct',
  DSSquarePayment = 'DSSquarePayment',
  WorkflowSharing = 'WorkflowSharing',
  'AI-assistant' = 'AI-assistant',
  XmlImport = 'XmlImport',
  McpKeys = 'McpKeys',
  MaintenanceWork = 'MaintenanceWork',
  AiChat = 'AiChat',
  WebsiteShare = 'WebsiteShare',
  SquarePaymentIntegration = 'SquarePaymentIntegration',
  Helpdesk = 'Helpdesk',
  WhiteLabelRazorpay = 'WhiteLabelRazorpay',
  WhiteLabelPaystack = 'WhiteLabelPaystack',
  WhiteLabelMercadoPago = 'WhiteLabelMercadoPago',
  WhiteLabelGoCardless = 'WhiteLabelGoCardless',
  WhiteLabelFlutterwave = 'WhiteLabelFlutterwave',
  WhiteLabelSquare = 'WhiteLabelSquare',
  WhiteLabelSecureAndPay = 'WhiteLabelSecureAndPay',
  WhiteLabelXendit = 'WhiteLabelXendit',
  SubscriptionInvoices = 'SubscriptionInvoices',
  MigrateCustomLoginPage = 'MigrateCustomLoginPage',
  WhiteLabelDeletion = 'WhiteLabelDeletion',
  VatViesBackgroundValidation = 'VatViesBackgroundValidation',
  TransactionalSender = 'TransactionalSender',
  ClientsStorageUsage = 'ClientsStorageUsage',
}

export type FlagsPropsType = {
  flags: {
    [key in GrowthbookFlagsEnum]: boolean
  }
}
